import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@storyblok/react/dist/bridge-loader.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@storyblok/react/dist/story.mjs");
